import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Carousel } from 'components/Carousel/Carousel';
import media from 'decorators/Media/Media';
import { testimonialsData as data } from './testimonialsData';

export const TestimonialsUnwrapped = ({ backgroundColor, mediaQueryMd }) => {
  const testimonials = data;

  return (
    <div className={`testimonials bg--${backgroundColor || 'white'}`}>
      <div>
        <h2>
          <FormattedMessage id="testimonials.header" defaultMessage="What members have to say" />
        </h2>
        <Carousel
          className="carousel--testimonials"
          cellAlign="left"
          edgeEasing="easeCubicOut"
          speed={150}
          slidesToShow={1}
          slidesToScroll={1}
          showMobileControls={!mediaQueryMd}
          showDesktopControlsCenter={mediaQueryMd}>
          {testimonials.map(testimonial => (
            <div className="testimonials__item" key={testimonial.source}>
              <blockquote>{testimonial.quote}</blockquote>
              <div className="testimonials__item__source">
                <span>
                  <h3>{testimonial.source}</h3>
                  <p>{testimonial.location}</p>
                </span>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

TestimonialsUnwrapped.propTypes = {
  mediaQueryMd: PropTypes.bool,
  backgroundColor: PropTypes.oneOf(['white', 'light']),
};

export const Testimonials = media(TestimonialsUnwrapped);
